module.exports = __webpack_public_path__ + "static/media/ngmap.34117c25.svg";